import React from "react";

import {
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import GiftActivatedForm from "./GiftActivatedForm";
// ----------------------------------------------------------------------
export default function GiftActivatedEditBtn({ editData }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <IconButton aria-label="details" size="small" onClick={handleClickOpen}>
        <EditIcon />
      </IconButton>
      <Dialog open={open} fullWidth>
        <DialogTitle>Modification</DialogTitle>
        <DialogContent>
          <GiftActivatedForm
            editData={editData}
            onComplete={() => handleClose()}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
